export default [
  { name: 'United States', value: 'US' },
  { name: 'Ireland', value: 'IE' },
];
